import {
  apiClient,
  type MonthlyTourReportSummaryExEntity,
  type PageEntity
} from '@/libs/api'
import { type MonthlyTourReportSummariesRequestQuery } from '@/libs/api/types'

export type FetchMonthlyTourReportSummariesQuery = {
  tenantKey: string
  query: MonthlyTourReportSummariesRequestQuery
}

export type FetchMonthlyTourReportSummariesResponse = {
  data: MonthlyTourReportSummaryExEntity[]
  pagination: PageEntity | null
}

/**
 * 月次支払レポートの範囲集計を取得する (#4421)。
 * パートナーごとに 1 行で、計上月をまたいでも 1 行にまとまる。
 */
export const fetchMonthlyTourReportSummaries = async (
  { tenantKey, query }: FetchMonthlyTourReportSummariesQuery,
  signal?: AbortSignal
): Promise<FetchMonthlyTourReportSummariesResponse> => {
  const { data, pagination } = await apiClient
    ._tenant(tenantKey)
    .monthly_tour_reports.summary.$get({ query, config: { signal } })
  return { data, pagination }
}
